export default __webpack_public_path__ + "static/health_b.abe34b9d7d8b6467bef8ee10f5a73964.png";